import { toCsv, isoDay } from "./csv";
import { STATUS } from "./format";
import { waitingDays } from "./format";

// The Cases list as a CSV file, one row per case, with what the list shows
// (rania-37): who, what, where it stands, the money and who owns it.
const COLUMNS = [
  { label: "Case", value: (c) => c.id },
  { label: "Customer", value: (c) => c.customer?.name || "" },
  { label: "Email", value: (c) => c.customer?.email || "" },
  { label: "Travellers", value: (c) => c.travellers },
  { label: "Destination", value: (c) => c.destination || "" },
  { label: "Product", value: (c) => c.product || "" },
  { label: "Visa type", value: (c) => c.visa_type || "" },
  { label: "Status", value: (c) => STATUS[c.status]?.label || c.status || "" },
  { label: "Paid", value: (c) => (c.status === "incomplete" ? "" : c.is_paid ? "Paid" : "Not paid") },
  { label: "Total (USD)", value: (c) => Number(c.total || 0).toFixed(2) },
  { label: "Submitted", value: (c) => isoDay(c.submitted_at) },
  { label: "Days waiting", value: (c) => (["pending", "under_review"].includes(c.status) ? waitingDays(c.submitted_at) ?? "" : "") },
  { label: "Trip", value: (c) => c.travel_date || "" },
  { label: "Owner", value: (c) => c.assigned?.name || "" },
  { label: "Documents to review", value: (c) => (c.to_review == null ? "" : c.to_review) },
  { label: "New copies", value: (c) => (c.needs_new == null ? "" : c.needs_new) },
  { label: "Approved", value: (c) => isoDay(c.approved_at) },
  { label: "Partner", value: (c) => c.partner?.name || "" },
];

export const casesCsv = (rows) => toCsv(rows, COLUMNS);
